export const SmsEnabledPhoneNumber: Record<string, string[]> = {
  CH: ["+4174", "+4175", "+4176", "+4177", "+4178", "+4179"],
  DE: ["+4915", "+4916", "+4917"],
  FR: ["+336", "+337"],
  IT: ["+393"],
}
export const DefaultMask = "+0000000000000000000000"

export const checkIfSMSEnabled = (countryCode: string, phoneNumber: string) => {
  if (!SmsEnabledPhoneNumber[countryCode]) return true

  const prefixLength = SmsEnabledPhoneNumber[countryCode][0].length
  if (phoneNumber.length >= prefixLength) {
    return SmsEnabledPhoneNumber[countryCode].includes(phoneNumber.substring(0, prefixLength))
  }

  return true
}
